import cortanaComposeStore from '../store/cortanaComposeStore';
import createCortanaComposeViewState from '../utils/createCortanaComposeViewState';
import { mutatorAction } from 'satcheljs';
import PluginCallbacks from '../store/schema/PluginCallbacks';

export default mutatorAction('resetViewState', function resetViewState(
    pluginCallbacks: PluginCallbacks
) {
    cortanaComposeStore.viewState = createCortanaComposeViewState(pluginCallbacks);
});
